module.exports = __webpack_public_path__ + "static/media/successTick.7d8444d9.svg";